module.exports = __webpack_public_path__ + "img/woman-noodles.ae18d24c.png";